<script setup>
import { tv } from 'tailwind-variants';

/**
 * @typedef {object} PopoverCardProps
 * @property {boolean} [isUnstyled=false] - Whether the popover card is unstyled
 */

/**
 * @type {PopoverCardProps}
 */
const props = defineProps({
  isUnstyled: {
    type: Boolean,
    default: false,
  },
});

const popoverPanelRecipe = tv({
  base: 'z-0',
  variants: {
    isUnstyled: {
      true: '',
      false: [
        'relative shadow-brand-300 rounded-xl before:content-[""] before:absolute before:inset-0 before:z-10 before:rounded-xl before:pointer-events-none before:mix-blend-luminosity before:shadow-brand-bevel-100',
        'dark:shadow-none dark:before:hidden dark:border dark:border-brand-border',
      ],
    },
  },
});
</script>

<template>
  <div
    data-component="CsPopoverPanel"
    tabindex="-1"
    :class="popoverPanelRecipe(props)"
  >
    <slot />
  </div>
</template>
